import React, { useContext, useCallback } from 'react'
import { UserContext } from 'stores/UserStore'
import { AppContext } from 'stores/AppStore'
import Header from 'components/layout/Header'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import AppLogo from 'assets/images/logo.png'


const AppHeader = () => {
  const { t } = useTranslation()
  const { isHeaderVisible, pageTitle, pageSubtitle } = useContext(AppContext)
  const { authState, signOut, currentUser } = useContext(UserContext)
  const history = useHistory()

  const redirect = useCallback(path => () => {
    history.push(path)
  }, [history])

  const sideMenuSettings = {
    appLogoSrc: AppLogo,
    itemGroups: [
      {
        key: 'no-header',
        items: [
          {
            key: 'search',
            icon: 'apps',
            label: t(pageTitle),
            onClick: () => {
              history.goBack()
              history.push('/')
            }
          }
        ]
      },
      {
        key: 'empty-header',
        items: [
          {
            key: 'empty',
            icon: '',
            label: t(''),
            onClick: () => ''
          }
        ]
      }      
    ]
  }

  const userSettings = {
    username: currentUser ? currentUser.name : currentUser,
    options: [
      {
        key: 'version',
        label: 'v' + process.env.REACT_APP_VERSION,
        onClick: () => { }
      },
      {
        key: 'sign-out',
        label: t('Sign Out'),
        onClick: signOut,
        divider: true
      }
    ]
  }

  const home = {
    onClick: () => window.location.href = process.env.REACT_APP_HOME_URL
  }

  const apps = currentUser && currentUser.applications.map(app => {
    return {
      key: app.id,
      label: app.label,
      iconSrc: app.icon,
      onClick: () => window.location.href = app.link
    }
  })

  return isHeaderVisible && authState === 'SIGNED_IN' ?
    <Header
      title={pageTitle}
      homeIcon={home}
      sideMenuSettings={sideMenuSettings}
      subtitle={pageSubtitle}
      onAppIconClick={redirect('/')}
      userSettings={userSettings}
      apps={apps} />
    : null
}

export default AppHeader
